import React from 'react';
import './_styles.scss';

interface LoadingBarProps {
  isLoading?: boolean;
}

export default function LoadingBar({ isLoading }: LoadingBarProps) {
  return (
    <div
      className={`loading-bar ${isLoading ? 'is-loading' : ''}`}
      style={{
        height: isLoading ? 8 : 0
      }}
    ></div>
  );
}
